import * as Yup from 'yup';

const productLineSchema = Yup.object({
  id: Yup.number().required(),
  name: Yup.string().required(),
  productLine: Yup.string().required(),
});

const bundleProductConfigurationsSchema = Yup.object({
  value: Yup.string().required(),
  configuration: Yup.object({
    id: Yup.number().required(),
    identifier: Yup.string().required(),
    description: Yup.string().nullable(),
  }).required(),
});

const priceSchema = Yup.object({
  id: Yup.number().required(),
  price: Yup.number().min(0)
    .required(),
  type: Yup.string().required(),
});

const colorImageSchema = Yup.object({
  id: Yup.number().required(),
  productId: Yup.number().required(),
  color: Yup.object({
    id: Yup.number().required(),
    label: Yup.string().required(),
    labelEn: Yup.string().required(),
    tsiColorId: Yup.string().required(),
    name: Yup.string().required(),
    rgb: Yup.string().required(),
  }).required(),
  img1: Yup.string().nullable(),
  img2: Yup.string().nullable(),
  img3: Yup.string().nullable(),
});

const manufacturerSchema = Yup.object({
  id: Yup.number().required(),
  name: Yup.string().required(),
});

const productSchema = Yup.object({
  id: Yup.number().required(),
  productLine: productLineSchema.required(),
  productGroupId: Yup.mixed().nullable(),
  labelId: Yup.mixed().nullable(),
  manufacturer: manufacturerSchema,
  model: Yup.string().required(),
  desc: Yup.string().nullable(),
  descEn: Yup.string().nullable(),
  status: Yup.number().oneOf([0, 1])
    .required(),
  statusBusiness: Yup.number().oneOf([0, 1])
    .required(),
  groupMaster: Yup.boolean().required(),
  outlet: Yup.boolean().required(),
  label: Yup.string().nullable(),
  productCharacteristics: Yup.array().of(Yup.object())
    .required(),
  productImages: Yup.array().of(Yup.object())
    .required(),
  productColorsImages: Yup.array().of(colorImageSchema)
    .required(),
  productPrices: Yup.array().of(Yup.object())
    .required(),
  addons: Yup.array().of(Yup.object())
    .required(),
});

const bundleProductSchema = Yup.object({
  id: Yup.number().required(),
  isMaster: Yup.boolean(),
  useOriginalPrices: Yup.boolean(),
  bundleProductConfigurations: Yup.array().of(bundleProductConfigurationsSchema),
  bundleProductPrices: Yup.array().of(priceSchema),
  product: productSchema.required(),
});

const bundleSchema = Yup.object({
  id: Yup.number().required(),
  identifier: Yup.string().required(),
  name: Yup.string().required(),
  status: Yup.number().oneOf([0, 1])
    .required(),
  productLine: productLineSchema.required(),
  bundleProducts: Yup.array().of(bundleProductSchema)
    .required(),
}).required();

export default bundleSchema;
